import styled from 'styled-components'
import InputField, { Props } from 'components/form/InputField'

export default function InputFieldSideBySide(props: Props): JSX.Element {
  return <StyledInputField {...props} />
}

const StyledInputField = styled(InputField)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  margin: 5px 0 30px;

  & > label {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: relative;
    height: 40px;
    width: 100px;
    margin: 0 10px 0 0;
    font-weight: 500;
  }
  & > div {
    flex: 1;
    height: 40px;
  }
`
